<template>
	<div>
		<h4 class="text-center">RECONCILE REPORTING SYSTEM</h4>

		<div class="row">

			<div class="col-auto mb-2 text-left">
				<form class="form-inline">
				  <div class="form-group">
				    <label for="reportTypeClient" class="sr-only">Report Type</label>
				    <input type="text" disabled class="form-control-plaintext py-0" id="reportTypeClient" style="width: 109px;" value="Report Type">
				  </div>
					<select class="custom-select py-0 pl-2 pr-0" style="height: 33px; width: 80px; background-color: transparent; border-color:  rgb(43, 53, 83); font-size: 13px;" v-model="reportType">
					  <option value="all" style="background-color: #1a1e34;">ALL</option>
					  <option value="day" style="background-color: #1a1e34;">DAILY</option>
					  <option value="week" style="background-color: #1a1e34;">WEEKLY</option>
					  <option value="month" style="background-color: #1a1e34;">MONTHLY</option>
					  <option value="year" style="background-color: #1a1e34;">YEARLY</option>
					</select>
				</form>
			</div>

			<div v-if="reportType != 'all'" class="col-auto mb-2">
				<form class="form-inline">
				  <div class="form-group">
				    <label for="reportPeriodClient" class="sr-only">Report Period</label>
				    <input type="text" disabled class="form-control-plaintext py-0" id="reportPeriodClient" style="width: 120px;" value="Report Period">
				  </div>

				  <template v-if="reportType == 'day'">
						<div class="form-group mr-2">
							<label for="filterStartDateClient" class="sr-only">Start Date</label>
							<input type="date" class="form-control py-0" id="filterStartDateClient" style="height: 33px;" min="2020-01-01" :max="endDateDay" v-model="startDateDayInInput">
						</div>

						<div class="form-group">
							<label for="filterEndDateDayClient" class="sr-only">End Date</label>
							<input type="date" class="form-control py-0" id="filterEndDateDayClient" style="height: 33px;" :min="startDateDayInInput" :max="dateToday" v-model="endDateDay">
						</div>
					</template>

					<template v-if="reportType == 'week'">
						<input list="weeklyDateListClient" name="location" id="startDateWeek" class="form-control" style="height: 33px;" v-model.lazy="startDateWeekInInput" onfocus="this.value=''" onchange="this.blur();" required>
						<datalist id="weeklyDateListClient">
							<option v-for="item in weeklyDateList " :key="`${item}Week`" :value="item"></option>
						</datalist>

						<div class="form-group ml-2">
							<label for="filterEndDateWeekClient" class="sr-only">End Date</label>
							<input type="date" class="form-control c-disabled py-0" id="filterEndDateWeekClient" style="height: 33px;" v-model="endDateWeek" disabled>
						</div>
					</template>

					<template v-if="reportType == 'month'">
						<input list="monthlyDateListClient" name="location" id="startDateMonth" class="form-control" style="height: 33px;" v-model.lazy="startDateMonthInInput" onfocus="this.value=''" onchange="this.blur();" required>
						<datalist id="monthlyDateListClient">
							<option v-for="item in monthlyDateList " :key="`${item}Month`" :value="item"></option>
						</datalist>
						
						<div class="form-group ml-2">
							<label for="filterEndDateMonthClient" class="sr-only">End Date</label>
							<input type="date" class="form-control c-disabled py-0" id="filterEndDateMonthClient" style="height: 33px;" v-model="endDateMonth" disabled>
						</div>
					</template>

					<template v-if="reportType == 'year'">
						<input list="yearlyDateListClient" name="location" id="startDateYear" class="form-control" style="height: 33px;" v-model.lazy="startDateYearInInput" onfocus="this.value=''" onchange="this.blur();" required>
						<datalist id="yearlyDateListClient">
							<option v-for="item in yearlyDateList " :key="`${item}Year`" :value="item"></option>
						</datalist>

						<div class="form-group ml-2">
							<label for="filterEndDateYearClient" class="sr-only">End Date</label>
							<input type="date" class="form-control c-disabled py-0" id="filterEndDateYearClient" style="height: 33px;" v-model="endDateYear" disabled>
						</div>
					</template>

				</form>
			</div>

			<div class="col-auto mb-2">
				<ExportAsButton class="d-inline-block">
				</ExportAsButton>
			</div>

		</div>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="text-center"></h4>
						<div class="row">
							<div class="col-12 col-md-6">
								<dl class="row mb-0">
									<dt class="col-6">USER ACCESS</dt>
									<dd class="col-6">
										<p>: CLIENT</p>
									</dd>

									<dt class="col-6">HIN</dt>
									<dd class="col-6">
										<p>: {{this.$store.getters.getHin}} </p>
									</dd>

									<dt class="col-6">ACCOUNT NAME</dt>
									<dd class="col-6">
										<p>: {{this.$store.getters.getFirstName}} </p>
									</dd>
								</dl>
							</div>

							<div class="col-12 col-md-6">
								<dl class="row mb-0">
									<dt class="col-auto">TOTAL TURN OVER</dt>
									<dd class="col-6">
										<dl class="row mb-0">
											<dt class="col-12"></dt>
											<dd class="col-9"><p>USD {{Number((totalTurnOver.usd).toFixed(2))}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>IDR {{Number((totalTurnOver.anotherCurrency).toFixed(2))}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>TOZ {{Number((totalTurnOver.toz).toFixed(2))}}</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>GRAM {{totalTurnOver.gram}}</p></dd>
										</dl>
									</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">PRODUCT</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">BUY</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">SELL</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL TRADE <br> VOLUME <br> (USD)</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> TOZ</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> GRAM</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">RATE <br> RATIO <br> (%)</th>
						</tr>
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>

							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="rrsClientStatus != 'loading'">
							<tr v-for="(product, index) in products" class="c-row-table text-right" v-bind:key="product.id">
								<td class="text-center">{{index + 1}}</td>
								<td class="text-left">{{product.name}}</td>
								<td>{{(product.buy.total_price).toFixed(2)}}</td>
								<td>{{(product.buy.total_gram * grToTozMultiplier).toFixed(2)}}</td>
								<td>{{product.buy.total_gram}}</td>
								<td>{{(product.sell.total_price).toFixed(2)}}</td>
								<td>{{(product.sell.total_gram * grToTozMultiplier).toFixed(2)}}</td>
								<td>{{product.sell.total_gram}}</td>
								<td>{{(product.total_trade).toFixed(2)}}</td>
								<td>{{(product.total_gram * grToTozMultiplier).toFixed(2)}}</td>
								<td>{{product.total_gram}}</td>
								<td class="text-center">{{product.rateRatio}}</td>
							</tr>
							<tr v-if="products.length < 1">
								<td colspan="12" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="14">
									<Loader
										size_prop="10em"
									></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	import Loader from '@/components/Loader.vue'
	import ExportAsButton from '@/components/ExportAsButton.vue'

	export default {
		name: 'CentralCounterParty',

		props: {
			hin_prop: {
				type: String,
				default: ''
			},
			reportType_prop: {
				type: String,
				default: ''
			},
			startDate_prop: {
				type: String,
				default: ''
			},
			endDate_prop: {
				type: String,
				default: ''
			},
		},

		components: {
			Loader,
			ExportAsButton
		},

		data() {
			const today = new Date(Date.now())
			let todayDay = today.getDay()
			let tempDay = new Date(Date.now())
			let tempWeek = new Date(Date.now())
			let tempMonth = new Date(Date.now())
			let tempYear = new Date(Date.now())
			return {
				grToTozMultiplier: 0.0321507,

				rrsClientStatus: 'loading',
				products: [],
				
				totalTurnOver: {
					usd: 0,
					anotherCurrency: 0,
					toz: 0,
					gram: 0
				},

				reportType: 'all',
				reportMonth: 'january',
				reportYear: '2019',

				dateToday: `${tempDay.getFullYear()}-${tempDay.getMonth() + 1 < 10 ? '0' : ''}${tempDay.getMonth() + 1}-${tempDay.getDate()< 10 ? '0' : ''}${tempDay.getDate()}`,

				startDateDay: new Date(tempDay.setDate(tempDay.getDate() - 1)),
				// startDateDay: '',
				endDateDay: `${tempDay.getFullYear()}-${tempDay.getMonth() + 1 < 10 ? '0' : ''}${tempDay.getMonth() + 1}-${tempDay.getDate() + 1 < 10 ? '0' : ''}${tempDay.getDate() + 1}`,
				// endDate: '',

				startDateWeek: new Date(tempWeek.setDate(tempWeek.getDate() - todayDay + 1)),
				weeklyDateList: [],

				startDateMonth: new Date(tempMonth.setDate(1)),
				monthlyDateList: [],

				startDateYear: new Date(new Date(tempYear.setDate(1)).setMonth(0)),
				yearlyDateList: [],
			}
		},

		computed: {
			watcherChangeFilter() {
				return `${this.startDateDay}${this.startDateWeek}${this.startDateMonth}${this.startDateYear}${this.endDateDay}${this.hin_prop}${this.reportType_prop}${this.startDate_prop}${this.endDate_prop}`
			},

			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			startDateDayInInput: {
				get: function() {
					let temp = this.startDateDay
					if (temp) {
						return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					this.startDateDay = new Date(newValue)
				}
			},

			startDateWeekInInput: {
				get: function() {
					let temp = this.startDateWeek
					if (temp) {
						return `${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateWeek = temp
				}
			},
			endDateWeek() {
				let temp = this.startDateWeek
				if (temp) {
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() + 4 < 10 ? '0' : ''}${temp.getDate() + 4}`
				}else {
					return ''
				}
			},

			startDateMonthInInput: {
				get: function() {
					let temp = this.startDateMonth
					if (temp) {
						return `01/${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
					this.startDateMonth = temp
				}
			},
			endDateMonth() {
				let temp = this.startDateMonth
				if (temp) {
					temp.setMonth(temp.getMonth() + 1)
					temp.setDate(temp.getDate() - 1)
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
				}else {
					return ''
				}
			},

			startDateYearInInput: {
				get: function() {
					let temp = this.startDateYear
					if (temp) {
						return `01/01/${temp.getFullYear()}`
					}else {
						return ''
					}
				},
				set: function(newValue) {
					if (newValue) {
						let temp = new Date(`${newValue.substr(6, 4)}-${newValue.substr(3, 2)}-${newValue.substr(0, 2)}`)
						this.startDateYear = temp
					}
				}
			},
			endDateYear() {
				let temp = this.startDateYear
				if (temp) {
					temp.setFullYear(temp.getFullYear() + 1)
					temp.setDate(temp.getDate() - 1)
					return `${temp.getFullYear()}-${temp.getMonth() + 1 < 10 ? '0' : ''}${temp.getMonth() + 1}-${temp.getDate() < 10 ? '0' : ''}${temp.getDate()}`
				}else {
					return ''
				}
			}
		},

		watch: {
			watcherChangeFilter() {
				this.changeFilter()
			},

			reportType(newValue) {
				if (newValue == 'week') {
					if (this.weeklyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayDay = todayDate.getDay()
						let nearestMondayDate = new Date(todayDate.setDate(todayDate.getDate() - todayDay + 1))

						while (nearestMondayDate.getFullYear() >= 2020) {
							this.weeklyDateList.push(`${nearestMondayDate.getDate() < 10 ? '0' : ''}${nearestMondayDate.getDate()}/${nearestMondayDate.getMonth() + 1 < 10 ? '0' : ''}${nearestMondayDate.getMonth() + 1}/${nearestMondayDate.getFullYear()}`)
							nearestMondayDate = new Date(nearestMondayDate.setDate(nearestMondayDate.getDate() - 7))
						}

					}
				}else if (newValue == 'month') {
					if (this.monthlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let todayMonth = todayDate.getMonth() // 0 = January
						let monthDate = new Date(todayDate.getFullYear() + '-' + (todayMonth + 1 < 10 ? '0' : '') + String(todayMonth + 1) + '-01')

						while (monthDate.getFullYear() >= 2020) {
							this.monthlyDateList.push(`01/${monthDate.getMonth() + 1 < 10 ? '0' : ''}${monthDate.getMonth() + 1}/${monthDate.getFullYear()}`)
							monthDate =  new Date(monthDate.setMonth(monthDate.getMonth() - 1))
						}

					}
				}else {
					if (this.yearlyDateList.length < 1) {

						let todayDate = new Date(Date.now())
						let yearDate = new Date(todayDate.getFullYear() + '-01-01')

						while (yearDate.getFullYear() >= 2020) {
							this.yearlyDateList.push(`01/01/${yearDate.getFullYear()}`)
							yearDate =  new Date(yearDate.setFullYear(yearDate.getFullYear() - 1))
						}
					
					}
				}
				
				this.changeFilter()
			}
		},

		created() {
			console.log('WKWKKWKW', this.startDateDayInInput, this.startDateWeekInInput, this.startDateWeek)

			this.changeFilter()
		},

		methods: {
			changeFilter() {
				if (this.hin_prop == '') {
					let startDate = this.startDateDay
					let endDate = this.endDateDay

					if (this.reportType == 'all') {
						startDate = ''
						endDate = ''
					}else if (this.reportType == 'day') {
						startDate = this.startDateDay
					}else if (this.reportType == 'week') {
						startDate = this.startDateWeek
						endDate = ''
					}else if (this.reportType == 'month') {
						startDate = this.startDateMonth
						endDate = ''
					}else {
						startDate = this.startDateYear
						endDate = ''
					}

					if (startDate) {
						startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1 < 10 ? '0' : ''}${startDate.getMonth() + 1}-${startDate.getDate() < 10 ? '0' : ''}${startDate.getDate()}`
					}

					this.rrsClientStatus = 'loading'
					this.products = []
					axios({
						method: 'get',
						url:process.env.VUE_APP_BACKEND_URL+'/rrs/client?type='+ this.reportType +'&startDate='+ startDate +'&endDate='+ endDate
					}).then(response => {
						let temp = response.data.data
						console.log('berhasil rrs client', response, this.products)
						temp.contract_micro.name = 'DG001 0.01 GR POOL'
						temp.contract_1gr.name = 'DG1 1 GR POOL'
						temp.contract_100gr.name = 'DG100 100 GR NON POOL'
						temp.contractId_10oz.name = 'DG1K 1 KG NON POOL'
						temp.contract_10kg.name = 'DG10K 10 KG NON POOL'

						temp.contract_micro.weight = 0.01
						temp.contract_1gr.weight = 1
						temp.contract_100gr.weight = 100
						temp.contractId_10oz.weight = 1000
						temp.contract_10kg.weight = 10000

						this.products = [temp.contract_micro, temp.contract_1gr, temp.contract_100gr, temp.contractId_10oz, temp.contract_10kg]

						let tempUsd = 0
						let tempGram = 0
						this.products.forEach((product, index) => {

							this.products[index].buy.total_price = Number((this.products[index].buy.total_price).toFixed(2))
							this.products[index].buy.totalToz = Number((product.buy.total_gram * this.grToTozMultiplier).toFixed(2))
							this.products[index].buy.total_gram = Number((this.products[index].buy.total_gram).toFixed(2))

							this.products[index].sell.total_price = Number((this.products[index].sell.total_price).toFixed(2))
							this.products[index].sell.totalToz = Number((product.sell.total_gram * this.grToTozMultiplier).toFixed(2))
							this.products[index].sell.total_gram = Number((this.products[index].sell.total_gram).toFixed(2))
							
							this.products[index].total_trade = Number((this.products[index].total_trade).toFixed(2))
							this.products[index].totalToz = Number((product.total_gram * this.grToTozMultiplier).toFixed(2))
							this.products[index].total_gram = Number((this.products[index].total_gram).toFixed(2))

							this.products[index].rateRatio = Number(((product.sell.total_price / (product.sell.total_price + product.buy.total_price)) * 100).toFixed(2))

							this.products[index].rateRatio = (product.sell.total_price / (product.sell.total_price + product.buy.total_price)) * 100

							tempUsd += product.total_trade
							tempGram += product.total_gram
						})

						this.totalTurnOver = {
							usd: tempUsd,
							anotherCurrency: tempUsd * this.streamingRate.streamBuy,
							toz: tempGram * this.grToTozMultiplier,
							gram: tempGram,
						}

						this.rrsClientStatus = 'success'
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}

						this.rrsClientStatus = 'error'
						console.log('gagal rrs client', error.config);
					})		
				}else {
					this.rrsClientStatus = 'loading'
					this.products = []
					axios({
						method: 'get',
						url:process.env.VUE_APP_BACKEND_URL+'/rrs/ib/client?hin=' + this.hin_prop + '&type=' + this.reportType_prop + ' &startDate=' + this.startDate_prop + '&endDate=' + this.endDate_prop
						
					}).then(response => {
						let temp = response.data.data
						temp.contract_micro.name = 'DG001 0.01 GR POOL'
						temp.contract_1gr.name = 'DG1 1 GR POOL'
						temp.contract_100gr.name = 'DG100 100 GR NON POOL'
						temp.contractId_10oz.name = 'DG1K 1 KG NON POOL'
						temp.contract_10kg.name = 'DG10K 10 KG NON POOL'

						temp.contract_micro.weight = 0.01
						temp.contract_1gr.weight = 1
						temp.contract_100gr.weight = 100
						temp.contractId_10oz.weight = 1000
						temp.contract_10kg.weight = 10000

						this.products = [temp.contract_micro, temp.contract_1gr, temp.contract_100gr, temp.contractId_10oz, temp.contract_10kg]

						let tempUsd = 0
						let tempGram = 0
						this.products.forEach((product, index) => {
							this.products[index].rateRatio = (product.sell.total_price / (product.sell.total_price + product.buy.total_price)) * 100

							tempUsd += product.total_trade
							tempGram += product.total_gram
						})

						this.totalTurnOver = {
							usd: tempUsd,
							anotherCurrency: tempUsd * this.streamingRate.streamBuy,
							toz: tempGram * this.grToTozMultiplier,
							gram: tempGram,
						}

						this.rrsClientStatus = 'success'
						console.log('berhasil rrs client', response, this.products)
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}

						this.rrsClientStatus = 'error'
						console.log('gagal rrs client', error.config);
					})	
				}
			},

			clearStartDate(value) {
				if (value == 'week') {
					this.startDateWeek = ''
				}else if (value == 'month') {
					this.startDateMonth = ''
				}else if (value == 'year') {
					this.startDateYear = ''
				}
			}
		}
	}
</script>